export const ModalWidth = {
    Normal: 'Normal',
    Extra: 'Extra',
    Ultra: 'Ultra',
    Super: 'Super',
    Full: 'Full',
};
//# sourceMappingURL=types.js.map